// eslint-disable-next-line import/no-anonymous-default-export
export default {
    'title': 'Termini e Condizioni',
    'overview': 'Accetta tutti i termini e condizioni obbligatori per poter proseguire',
    'check': {
        'message': 'Devi accettare tutti i termini obbligatori per la fruizione del servizio'
    }
}
